import styled from 'styled-components';
import { PageFullWidth } from 'Ui';
import { ContactColumn } from './ContactColum';
import { useTranslatedLinks } from 'Utils/footerLinks';
import { useTranslation } from 'react-i18next';

const ContactsContainer = styled.div`
  display: flex;
  padding-bottom: 2.4rem;
  justify-content: flex-start;
  @media screen and (max-width: 48rem) {
    flex-direction: column;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    flex-direction: row;
  }
`;

const ContactContainer = styled.div`
  display: flex;
  justify-content: space-around;
  column-gap: 5rem;
  row-gap: 3rem;
  width: 100%;
  padding-right: 8rem;
  flex-wrap: wrap;
  @media screen and (max-width: 48rem) {
    flex-direction: column;
    gap: 24px;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    /* flex-wrap: wrap;
    flex-direction: row;
    justify-content: center; */
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 5rem;
    column-gap: 2.4rem;
    margin-bottom: 5rem;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  padding-bottom: 2.4rem;
  justify-content: flex-start;
  svg {
    width: 3.9rem;
    height: 3.8rem;
  }
`;

export const SiteMap = () => {
  const { t } = useTranslation('footer', { useSuspense: false });
  const footerTranslate = {
    titles: {
      about: t('titles.about'),
      help: t('titles.help'),
      offers: t('titles.offers'),
      clientSpace: t('titles.clientSpace'),
    },
  };
  const { FaqLinks, ServicesLinks, ClientLinks, aProposLinks } =
    useTranslatedLinks();
  return (
    <PageFullWidth style={{ width: '100%' }}>
      <ContactsContainer>
        <ContactContainer>
          <ContactColumn
            title={footerTranslate.titles.about}
            links={aProposLinks}
          />
          <ContactColumn title={footerTranslate.titles.help} links={FaqLinks} />
          <ContactColumn
            title={footerTranslate.titles.offers}
            links={ServicesLinks}
          />
          <ContactColumn
            title={footerTranslate.titles.clientSpace}
            links={ClientLinks}
          />
        </ContactContainer>
      </ContactsContainer>
    </PageFullWidth>
  );
};
